enum Flags {
  FdicRemediation = 'FF_fdic-remediation',
  BeneficiariesCommunityPropertyFix = 'FF_beneficiaries_community_property_fix',
  SsnTaxIdUiMaskingEnabled = 'FF_beneficiaries-ssn-ui-masking',
}

const defaultValues = {
  [Flags.FdicRemediation]: false,
  [Flags.BeneficiariesCommunityPropertyFix]: false,
  [Flags.SsnTaxIdUiMaskingEnabled]: true,
}

export { Flags, defaultValues }
